export const promoGrades = [
	{ id: 'intern', label: 'Стажёр' },
	{ id: 'junior', label: 'Junior' },
	{ id: 'middle', label: 'Middle' },
	{ id: 'middle_plus', label: 'Middle+' },
	{ id: 'senior', label: 'Senior' },
	{ id: 'lead', label: 'Lead' },
] as const;
export type PromoGrade = (typeof promoGrades)[number]['id'];
export type PromoDraft = {
	version: 2;
	courseId?: string;
	targetGrade?: PromoGrade;
	consented?: boolean;
	email?: string;
	authMode?: 'code' | 'password';
	owner?: string;
};
export function promoCourseDestination(courseId: string, attemptId?: string) {
	return `/course/${encodeURIComponent(courseId)}${attemptId ? '' : '?autostart=1&source=landing'}`;
}
export function promoStep(
	d: PromoDraft,
	authenticated: boolean,
	saved: boolean,
	linked: boolean,
	hasAttempt = false,
) {
	if (!d.courseId) return 'language';
	if (authenticated) {
		if (!saved && !hasAttempt) return 'save';
		return linked ? 'ready' : 'telegram';
	}
	if (!d.targetGrade) return 'grade';
	if (!d.consented) return 'consent';
	return d.authMode ?? 'email';
}
export function restoreDraft(
	raw: string | undefined,
	courses: string[],
	entryCourseId?: string,
): PromoDraft {
	try {
		const parsed = JSON.parse(raw ?? '{}');
		const d = parsed.version === 2 ? parsed : {};
		const courseId = entryCourseId ?? d.courseId;
		return {
			version: 2,
			courseId: courses.includes(courseId) ? courseId : undefined,
			targetGrade: promoGrades.some((g) => g.id === d.targetGrade)
				? d.targetGrade
				: undefined,
			consented: d.consented === true,
			email: typeof d.email === 'string' ? d.email.slice(0, 254) : undefined,
			authMode: ['code', 'password'].includes(d.authMode)
				? d.authMode
				: undefined,
			owner: typeof d.owner === 'string' ? d.owner : undefined,
		};
	} catch {
		return {
			version: 2,
			courseId: courses.includes(entryCourseId ?? '')
				? entryCourseId
				: undefined,
		};
	}
}
export function promoEvent(
	reach: (goal: string, params: Record<string, string>) => void,
	event: string,
	context: Record<string, unknown>,
) {
	const params: Record<string, string> = {};
	for (const key of [
		'courseId',
		'leadMagnetId',
		'step',
		'language',
		'grade',
		'action',
		'outcome',
		'document',
		'source',
	])
		if (typeof context[key] === 'string') params[key] = context[key] as string;
	try {
		reach(`interview_promo_${event}`, params);
	} catch {
		/* Optional analytics. */
	}
}
export const promoCookie = 'interview_promo_draft';
